// @flow

import React from 'react';
import { withTheme } from 'styled-components';
import type { Props } from 'common/components/DropDownMenu';
import DropDownMenu from 'common/components/DropDownMenu';

function FlatDropDownMenu(props: Props) {
  const {
    theme,
    extraCardStyle,
  } = props;

  const flatDropdownStyle = {
    width: theme.V2.metrics.dropdown.width,
    height: theme.V2.metrics.dropdown.height,
    boxShadow: 'none',
    border: `solid 1px ${theme.V2.colors.divider}`,
    backgroundColor: theme.V2.colors.background,
  };

  return (
    <DropDownMenu
      extraCardStyle={{ ...flatDropdownStyle, ...extraCardStyle }}
      {...props}
    />
  );
}


export default withTheme(FlatDropDownMenu);



// WEBPACK FOOTER //
// ./src/common/components/FlatDropDownMenu.js